/**
 * Enums for Employee Page Access
 * @readonly
 * @enum {name: {value: number}}
 */

export const EmployeePageAccess = Object.freeze({
  basicInfo: 1,
  workInfo: 2,
  governmentInfo: 3,
  educationInfo: 4,
  contactInfo: 5,
  visa: 6,
  dependents: 7,
  benefits: 8,
  leaves: 9,
  salary: 10,
  advance: 11,
  training: 12,
  assets: 13,
  memo: 14,
  seminar: 15,
  employmentRecord: 16,
  movement: 17,
  document: 18,
  requirements: 19,
  accessLevel: 20,
  medicalRecord: 21,
  performanceManagement: 22,
  workSchedule: 23,
  uploadPicture: 24,
  cpi: 25,
  location: 26,
});
export const EmployeePageAccessStatus = Object.freeze({
  basicInfo: { noAccess: '1', viewOnly: '2', edit: '3' },
  workInfo: { noAccess: '1', viewOnly: '2', edit: '3' },
  governmentInfo: { noAccess: '1', viewOnly: '2', edit: '3' },
  educationInfo: { view: '1', add: '2', edit: '3', delete: '4' },
  contactInfo: { view: '1', add: '2', edit: '3', delete: '4' },
  visa: { view: '1', add: '2', edit: '3', delete: '4' },
  dependents: { view: '1', add: '2', edit: '3', delete: '4' },
  benefits: { view: '1', add: '2', edit: '3', delete: '4' },
  leaves: { view: '1', add: '2', edit: '3', delete: '4' },
  salary: { view: '1', add: '2', edit: '3', delete: '4' },
  advance: { view: '1', add: '2', edit: '3', delete: '4' },
  training: { view: '1', add: '2', edit: '3', delete: '4' },
  assets: { view: '1', add: '2', edit: '3', delete: '4' },
  memo: { view: '1', add: '2', edit: '3', delete: '4' },
  seminar: { view: '1', add: '2', edit: '3', delete: '4' },
  employmentRecord: { view: '1', add: '2', edit: '3', delete: '4' },
  movement: { view: '1', add: '2', edit: '3', delete: '4' },
  document: { view: '1', add: '2', edit: '3', delete: '4' },
  requirements: { view: '1', add: '2', edit: '3', delete: '4' },
  accessLevel: { viewOnly: '2', edit: '3' },
  medicalRecord: { view: '1', add: '2' },
  performanceManagement: { view: '1', add: '2', edit: '3', delete: '4' },
  workSchedule: { view: '1', edit: '3' },
  uploadPicture: {
    /*  no need for page access */
  },
  cpi: { noAccess: '1', viewOnly: '2', edit: '3' },
  location: { viewOnly: '2', edit: '3' },
});
